
export class DebugDragAbleCont extends PIXI.Container {

    private dragging: boolean = false;
    private data: PIXI.InteractionData;
    private dragPoint: PIXI.Point = new PIXI.Point();
    private dragParent: boolean = false;

    constructor(parent: boolean = true) {
        super();
        this.dragParent = !!parent
    }

    protected unSubscribe(obj: PIXI.DisplayObject): void {
        obj.interactive = false;

        obj.off('mousedown', this.dragParent ? this.onDragParentStart : this.onDragStart)
            .off('touchstart', this.dragParent ? this.onDragParentStart : this.onDragStart)
            .off('mouseup', this.dragParent ? this.onDragParentEnd : this.onDragEnd)
            .off('mouseupoutside', this.dragParent ? this.onDragParentEnd : this.onDragEnd)
            .off('touchend', this.dragParent ? this.onDragParentEnd : this.onDragEnd)
            .off('touchendoutside', this.dragParent ? this.onDragParentEnd : this.onDragEnd)
            .off('mousemove', this.dragParent ? this.onDragParentMove : this.onDragMove)
            .off('touchmove', this.dragParent ? this.onDragParentMove : this.onDragMove)
    }

    protected subscribe(obj: PIXI.DisplayObject): void {
        obj.interactive = true;

        obj.on('mousedown', this.dragParent ? this.onDragParentStart : this.onDragStart)
            .on('touchstart', this.dragParent ? this.onDragParentStart : this.onDragStart)
            .on('mouseup', this.dragParent ? this.onDragParentEnd : this.onDragEnd)
            .on('mouseupoutside', this.dragParent ? this.onDragParentEnd : this.onDragEnd)
            .on('touchend', this.dragParent ? this.onDragParentEnd : this.onDragEnd)
            .on('touchendoutside', this.dragParent ? this.onDragParentEnd : this.onDragEnd)
            .on('mousemove', this.dragParent ? this.onDragParentMove : this.onDragMove)
            .on('touchmove', this.dragParent ? this.onDragParentMove : this.onDragMove)
    }

    private onDragParentStart(event: PIXI.InteractionEvent): void {
        if (!this.dragging) {
            this.data = event.data;
            this.dragging = true;
            this.parent.alpha /= 1.2;
            this.dragPoint = event.data.getLocalPosition(this.parent.parent);
            this.dragPoint.x -= this.parent.x;
            this.dragPoint.y -= this.parent.y;
        }
    }

    private onDragParentEnd() {
        if (this.dragging) {
            this.dragging = false;
            this.parent.alpha *= 1.2;
            this.data = null!;
        }
    }

    private onDragParentMove() {
        if (this.dragging) {
            const newPosition = this.data.getLocalPosition(this.parent.parent);
            this.parent.x = newPosition.x - this.dragPoint.x;
            this.parent.y = newPosition.y - this.dragPoint.y;
        }
    }

    private onDragStart(event: PIXI.InteractionEvent): void {
        if (!this.dragging) {
            this.data = event.data;
            this.dragging = true;
            this.alpha /= 1.2;
            this.dragPoint = event.data.getLocalPosition(this.parent);
            this.dragPoint.x -= this.x;
            this.dragPoint.y -= this.y;
        }
    }

    private onDragEnd() {
        if (this.dragging) {
            this.dragging = false;
            this.alpha *= 1.2;
            this.data = null!;
        }
    }

    private onDragMove() {
        if (this.dragging) {
            const newPosition = this.data.getLocalPosition(this.parent);
            this.x = newPosition.x - this.dragPoint.x;
            this.y = newPosition.y - this.dragPoint.y;
        }
    }
}